/**
 * SDK logger. Disabled by default. Enable via `debug: true` in configuration.
 * Mirrors Android Logger util.
 */
export class Logger {
  private static readonly PREFIX = "[tracker]";
  private static enabled = false;

  static setEnabled(enabled: boolean): void {
    Logger.enabled = enabled;
  }

  static debug(...args: unknown[]): void {
    if (Logger.enabled) console.debug(Logger.PREFIX, ...args);
  }

  static info(...args: unknown[]): void {
    if (Logger.enabled) console.info(Logger.PREFIX, ...args);
  }

  static warn(...args: unknown[]): void {
    if (Logger.enabled) console.warn(Logger.PREFIX, ...args);
  }

  static error(...args: unknown[]): void {
    if (Logger.enabled) console.error(Logger.PREFIX, ...args);
  }
}
